import { Component, Input } from '@angular/core';
import { TicketReportCellAlignmentEnum, TicketReportCellDataTypeEnum, TicketReportColumnDto, TicketReportColumnTemplateDto, TicketReportColumnValueTypeModeEnum, TicketReportDto, WorkflowDto } from '../../../../service/dto';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TicketReportFormComponent, MenuGroup } from '../ticket-report-form/ticket-report-form.component';
import { faHome, faTicket, IconDefinition, faUser, faUsers, faLayerGroup, faIcons, faBuilding, faAnglesRight, faKeyboard, faComputerMouse, faMessage, faComment, faDashboard, faMicrochip, faDotCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'app-ticket-report-form-sub-column-modal',
	standalone: false,
	templateUrl: './ticket-report-form-sub-column-modal.component.html',
	styleUrl: './ticket-report-form-sub-column-modal.component.scss'
})
export class TicketReportFormSubColumnModalComponent {
	@Input() workflow!: WorkflowDto;
	@Input() report!: TicketReportDto;
	@Input() column!: TicketReportColumnDto;
	form!: FormGroup;
	menu: MenuGroup[] = [];

	modeOptions: { value: TicketReportColumnValueTypeModeEnum, label: string }[] = [];
	alignmentOptions: { value: TicketReportCellAlignmentEnum, label: string }[] = [
		{ value: 'Left', label: 'Left' },
		{ value: 'Center', label: 'Center' },
		{ value: 'Right', label: 'Right' },
	];
	dataTypeOptions: { value: TicketReportCellDataTypeEnum, label: string }[] = [
		{ value: 'Text', label: 'Text' },
		{ value: 'Number', label: 'Number' },
		{ value: 'Currency', label: 'Currency' }
	];

	constructor(private fb: FormBuilder, private modalRef: NzModalRef, private messageService: NzMessageService) { }

	ngOnInit(): void {
		this.modeOptions = Object.keys(this.column.template!.modes).map(key => {
			const label = this.column.template!.modes[key] as string;
			return { value: key as TicketReportColumnValueTypeModeEnum, label };
		});
		this.column.subColumns = this.column.subColumns.sort((i1,i2)=>(i1.order??0)-(i2.order??0));

		this.form = this.fb.group({
			title: [this.column.title],
			mode: [this.column.mode ?? this.modeOptions[0].value],
			filterOperator: [this.column.filterOperator],
			filterValue: [this.column.filterValue],
			subColumns: this.fb.array(this.column.subColumns, [Validators.required]),
			alignment: [this.column.alignment, [Validators.required]],
			dataType: [this.column.dataType, [Validators.required]],
		});
		this.form.get('mode')!.valueChanges.subscribe(mode => {
			(this.form.get('subColumns') as FormArray).clear();
			this.menu = this.buildMenu(mode);
		});

		this.menu = this.buildMenu(this.form.get('mode')!.value);
	}
	buildMenu(mode: string): MenuGroup[] {
		const groups: { [key: string]: { [key: string]: TicketReportColumnTemplateDto[] } } = {};

		for (const t of this.workflow!.reportColumnTemplates) {
			if (t.type == 'DateDiff' || t.type == 'MonthDiff' || t.type == 'MinValue' || t.type == 'MaxValue' || t.type == 'Coalesce' || t.type == 'Concat') {
				continue;
			}
			if (t.modes[mode] == undefined) {
				continue;
			}

			if (!groups[t.group1]) {
				groups[t.group1] = {};
			}
			const subGroupKey = t.group2 || '_default';
			if (!groups[t.group1][subGroupKey]) {
				groups[t.group1][subGroupKey] = [];
			}
			groups[t.group1][subGroupKey].push(t);
		}

		return Object.keys(groups).map(group1 => ({
			label: group1,
			templates: groups[group1]['_default'] || [],
			subMenus: Object.keys(groups[group1])
				.filter(k => k !== '_default')
				.map(group2 => ({
					label: group2,
					payload: groups[group1][group2]
				}))
		}));
	}
	get subColumns(): FormArray {
		return this.form.get('subColumns') as FormArray;
	}
	removeItem(index: number): void {
		this.subColumns.removeAt(index);
		this.column.subColumns.splice(index, 1);
	}

	addColumn(input: TicketReportColumnTemplateDto) {
		const column: TicketReportColumnDto = {
			id: TicketReportFormComponent.getNextId(),
			createdAt: new Date(),
			title: input.name,
			mode: Object.keys(input.modes)[0] as TicketReportColumnValueTypeModeEnum,
			type: input.type,
			value: input.value,
			order: input.value,
			alignment: 'Left',
			dataType: 'Text',
			template: input,
			parentId: this.column.id,
			subColumns: [],
			hashCode: 0
		};
		this.column.subColumns.push(column);
		this.subColumns.push(this.fb.group(column));
	}



	handleDelete(): void {
		const idx = this.report.columns.findIndex(item => item.id === this.column.id);
		if (idx >= 0) this.report.columns.splice(idx, 1);
		this.modalRef.close(true);
	}

	handleSave(): void {
		let out = false;
		const title = this.form.get('title')!.value;
		const mode = this.form.get('mode')!.value;
		const filterOperator = this.form.get('filterOperator')!.value;
		const filterValue = this.form.get('filterValue')!.value;
		const alignment = this.form.get('alignment')!.value;
		const dataType = this.form.get('dataType')!.value;

		if (this.column.title !== title) {
			this.column.title = title;
			out = true;
		}
		if (this.column.mode !== mode) {
			this.column.mode = mode;
			out = true;
		}
		this.column.subColumns = this.subColumns.value;

		if (this.column.filterValue !== filterValue) {
			this.column.filterValue = filterValue;
			out = true;
		}
		if (this.column.filterOperator !== filterOperator) {
			this.column.filterOperator = filterOperator;
			out = true;
		}
		if (this.column.alignment !== alignment) {
			this.column.alignment = alignment;
			out = true;
		}
		if (this.column.dataType !== dataType) {
			this.column.dataType = dataType;
			out = true;
		}
		this.modalRef.close(out);
	}

	handleCancel(): void {
		this.modalRef.close(false);
	}

	getMenuIcon(input: TicketReportColumnTemplateDto) {
		switch (input.type) {
			case 'Ticket': return faTicket;
			case 'Member': return faUser;
			case 'Dependant': return faUsers;
			case 'Membership': return faLayerGroup;
			case 'Category': return faIcons;
			case 'Employer': return faBuilding;
			case 'Movement': return faAnglesRight;
			case 'Element': return faKeyboard;
			case 'Click': return faComputerMouse;
			case 'Communication': return faMessage;
			case 'Comment': return faComment;
			case 'Report': return faDashboard;
			case 'DateDiff': return faMicrochip;
			case 'MinValue': return faMicrochip;
			case 'MaxValue': return faMicrochip;
			case 'Coalesce': return faMicrochip;
			default: return faDotCircle;
		}
	}
}
